import _defineProperty from "/home/jenkins/jenkins_home/workspace/INSi-Consult-dev/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { actionChannel, call, take, put, select, delay } from 'redux-saga/effects';
import { dmpconnectActionConstants, apiSections, dmpconnectInitActionConstants, API_TYPES } from '../../constants';
import { checkConnector, handleDmpParameters, handleGetInteropCodes } from '../utilsSagas';
import getCommandAction from '../../actions/config/generateCommands';
import commands from '../../actions/config/commands';
import { clearSession, dmpCommandFailureContextualizedType, dmpCommandSuccessContextualizedType } from '../../actions/dmpconnectActions';
import { initApplicationFailure, initApplicationSuccess, logoutSuccess, setConnectorKo, setConnectorOk, setSessionKo, setSessionOk, setWsInitError, setWsInitLoading } from '../../actions/dmpconnectInitActions';
import { getApiType, getApplicationId, getCurrentPathname, getDcParams, getProductionMode, getRemoteControlAppName, getSessionId, getSessionTimeout, getTseActive, getTseWhoami, isRemoteControlActive } from '../../helpers/accessors';
import { formatOpenSessionParams } from '../../actions/config/commandParamsFormatters';
import { registerDcParameters, unregisterDcParameters } from "../initializationSagas";
var getConnectorStatus = function getConnectorStatus(_ref) {
  var connectorOk = _ref.dmpconnectInit.connectorOk;
  return connectorOk;
};
var initApplicationRest = /*#__PURE__*/_regeneratorRuntime().mark(function initApplicationRest() {
  var pathname, result;
  return _regeneratorRuntime().wrap(function initApplicationRest$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.next = 2;
        return select(getCurrentPathname);
      case 2:
        pathname = _context.sent;
        _context.next = 5;
        return put(setWsInitError(null));
      case 5:
        _context.next = 7;
        return put(setWsInitLoading(false));
      case 7:
        if (!(pathname === '/')) {
          _context.next = 16;
          break;
        }
        _context.next = 10;
        return put(setConnectorKo());
      case 10:
        _context.next = 12;
        return put(setSessionKo());
      case 12:
        _context.next = 14;
        return put(clearSession());
      case 14:
        _context.next = 16;
        return put(logoutSuccess());
      case 16:
        _context.next = 18;
        return call(handleGetInteropCodes);
      case 18:
        result = _context.sent;
        if (result) {
          _context.next = 30;
          break;
        }
        _context.next = 22;
        return put(setConnectorKo());
      case 22:
        _context.next = 24;
        return put(initApplicationFailure());
      case 24:
        _context.next = 26;
        return delay(5000);
      case 26:
        _context.next = 28;
        return call(initApplicationRest);
      case 28:
        _context.next = 36;
        break;
      case 30:
        _context.next = 32;
        return put(setConnectorOk(false));
      case 32:
        _context.next = 34;
        return call(handleDmpParameters);
      case 34:
        _context.next = 36;
        return put(initApplicationSuccess());
      case 36:
      case "end":
        return _context.stop();
    }
  }, initApplicationRest);
});
var handleCheckConnector = /*#__PURE__*/_regeneratorRuntime().mark(function handleCheckConnector() {
  var connectorStatus;
  return _regeneratorRuntime().wrap(function handleCheckConnector$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.next = 2;
        return select(getConnectorStatus);
      case 2:
        connectorStatus = _context2.sent;
        if (!(connectorStatus !== true)) {
          _context2.next = 8;
          break;
        }
        _context2.next = 6;
        return call(checkConnector, {
          retries: 10
        });
      case 6:
        _context2.next = 10;
        break;
      case 8:
        _context2.next = 10;
        return put(setConnectorOk());
      case 10:
      case "end":
        return _context2.stop();
    }
  }, handleCheckConnector);
});
var handleCheckSession = function handleCheckSession(_ref2) {
  var _ref2$createSession = _ref2.createSession,
    createSession = _ref2$createSession === void 0 ? true : _ref2$createSession;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var sessionId, dcParams, tseActive, tseWhoami, productionMode, applicationId, remoteControlActive, remoteControlAppName, sessionTimeout, openSessionParams, openSession, result, resultSession;
    return _regeneratorRuntime().wrap(function _callee$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (!(createSession === true)) {
            _context3.next = 67;
            break;
          }
          _context3.next = 3;
          return select(getSessionId);
        case 3:
          sessionId = _context3.sent;
          _context3.next = 6;
          return select(getDcParams);
        case 6:
          dcParams = _context3.sent;
          _context3.next = 9;
          return select(getTseActive);
        case 9:
          tseActive = _context3.sent;
          _context3.next = 12;
          return select(getTseWhoami);
        case 12:
          tseWhoami = _context3.sent;
          _context3.next = 15;
          return select(getProductionMode);
        case 15:
          productionMode = _context3.sent;
          _context3.next = 18;
          return select(getApplicationId);
        case 18:
          applicationId = _context3.sent;
          _context3.next = 21;
          return select(isRemoteControlActive);
        case 21:
          remoteControlActive = _context3.sent;
          _context3.next = 24;
          return select(getRemoteControlAppName);
        case 24:
          remoteControlAppName = _context3.sent;
          _context3.next = 27;
          return select(getSessionTimeout);
        case 27:
          sessionTimeout = _context3.sent;
          openSessionParams = {
            dcParams: dcParams,
            tseWhoami: tseActive ? tseWhoami : null,
            prodMode: productionMode,
            applicationId: remoteControlActive ? "".concat(applicationId, "-").concat(remoteControlAppName.replace(' ', '-')) : applicationId,
            sessionTimeout: sessionTimeout
          };
          openSession = true; // get session state
          if (!(sessionId !== undefined)) {
            _context3.next = 42;
            break;
          }
          _context3.next = 33;
          return put(getCommandAction(commands.getSessionState, apiSections.SESSION_STATE_SECTION, null, {
            synchronous: true,
            noRetries: true,
            silentError: true
          }));
        case 33:
          _context3.next = 35;
          return take([dmpCommandSuccessContextualizedType(apiSections.SESSION_STATE_SECTION), dmpCommandFailureContextualizedType(apiSections.SESSION_STATE_SECTION)]);
        case 35:
          result = _context3.sent;
          if (!(result && result.type === dmpCommandSuccessContextualizedType(apiSections.SESSION_STATE_SECTION))) {
            _context3.next = 40;
            break;
          }
          openSession = false;
          _context3.next = 42;
          break;
        case 40:
          _context3.next = 42;
          return put(setWsInitError(result.data));
        case 42:
          if (!(openSession === true)) {
            _context3.next = 61;
            break;
          }
          _context3.next = 45;
          return put(getCommandAction(commands.openSession, apiSections.SESSION_SECTION, formatOpenSessionParams(openSessionParams), {
            synchronous: true,
            silentError: true,
            noRetries: true
          }));
        case 45:
          _context3.next = 47;
          return take([dmpCommandSuccessContextualizedType(apiSections.SESSION_SECTION), dmpCommandFailureContextualizedType(apiSections.SESSION_SECTION)]);
        case 47:
          resultSession = _context3.sent;
          if (!(resultSession && resultSession.type === dmpCommandSuccessContextualizedType(apiSections.SESSION_SECTION))) {
            _context3.next = 57;
            break;
          }
          _context3.next = 51;
          return put(setSessionOk());
        case 51:
          _context3.next = 53;
          return put(setWsInitError(null));
        case 53:
          _context3.next = 55;
          return put(setWsInitLoading(false));
        case 55:
          _context3.next = 59;
          break;
        case 57:
          _context3.next = 59;
          return put(setWsInitError(resultSession.data));
        case 59:
          _context3.next = 67;
          break;
        case 61:
          _context3.next = 63;
          return put(setSessionOk());
        case 63:
          _context3.next = 65;
          return put(setWsInitError(null));
        case 65:
          _context3.next = 67;
          return put(setWsInitLoading(false));
        case 67:
        case "end":
          return _context3.stop();
      }
    }, _callee);
  })();
};
var handleGetPcscReaders = /*#__PURE__*/_regeneratorRuntime().mark(function handleGetPcscReaders() {
  return _regeneratorRuntime().wrap(function handleGetPcscReaders$(_context4) {
    while (1) switch (_context4.prev = _context4.next) {
      case 0:
        _context4.next = 2;
        return put(getCommandAction(commands.getPcscReaders, apiSections.PCSC_READERS_SECTION, null, {
          noRetries: true
        }));
      case 2:
      case "end":
        return _context4.stop();
    }
  }, handleGetPcscReaders);
});

/**
 * Handle one sequence at a time
 * @returns {IterableIterator<TakeEffect|CallEffect|ActionChannelEffect>}
 */
export var handleRESTSequence = /*#__PURE__*/_regeneratorRuntime().mark(function handleRESTSequence() {
  var _dmpProcesses;
  var dmpProcesses, requestChannel, payload, apiType;
  return _regeneratorRuntime().wrap(function handleRESTSequence$(_context5) {
    while (1) switch (_context5.prev = _context5.next) {
      case 0:
        dmpProcesses = (_dmpProcesses = {}, _defineProperty(_dmpProcesses, dmpconnectInitActionConstants.DMPC_RESET_APPLICATION, unregisterDcParameters), _defineProperty(_dmpProcesses, dmpconnectInitActionConstants.DMPC_INIT_APPLICATION, initApplicationRest), _defineProperty(_dmpProcesses, dmpconnectActionConstants.DMPC_GET_REST_PCSC_READERS, registerDcParameters), _defineProperty(_dmpProcesses, dmpconnectInitActionConstants.DMPC_DCPARAMS_REGISTERED, handleCheckSession), _defineProperty(_dmpProcesses, dmpconnectInitActionConstants.DMPC_SET_SESSION_OK, handleGetPcscReaders), _dmpProcesses);
        _context5.next = 3;
        return actionChannel(Object.keys(dmpProcesses));
      case 3:
        requestChannel = _context5.sent;
      case 4:
        if (!true) {
          _context5.next = 17;
          break;
        }
        _context5.next = 7;
        return take(requestChannel);
      case 7:
        payload = _context5.sent;
        _context5.next = 10;
        return select(getApiType);
      case 10:
        apiType = _context5.sent;
        if (!(apiType === API_TYPES.REST)) {
          _context5.next = 15;
          break;
        }
        if (!dmpProcesses[payload.type]) {
          _context5.next = 15;
          break;
        }
        _context5.next = 15;
        return call(dmpProcesses[payload.type], payload);
      case 15:
        _context5.next = 4;
        break;
      case 17:
      case "end":
        return _context5.stop();
    }
  }, handleRESTSequence);
});